import React from "react";
import Layout from "../Layout";
import WorkSchedule from "../../../widgets/supervisor/work-schedule/WorkSchedule";
import { days } from "../../../data/supervisor/work-schedule/workShedule";
import { initialData } from "../../../data/supervisor/work-schedule/workShedule";

function WorkScheduleSupervisor(props) {
  return (
    <Layout>
      <WorkSchedule days={days} initialData={initialData} />
    </Layout>
  );
}

export default WorkScheduleSupervisor;
